'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Divider } from '../Divider/Divider.js';

const StyledDivider = styled(Divider).withConfig({
  componentId: "sc-rglwv2-0"
})([""]);
const MenuDivider = /*#__PURE__*/withTitan(_a => {
  var {
      testId = 'menuDivider'
    } = _a,
    rest = __rest(_a, ["testId"]);
  return jsx(StyledDivider, Object.assign({
    direction: "horizontal",
    testId: testId
  }, rest));
}, {
  name: 'MenuDivider'
});

export { MenuDivider };
//# sourceMappingURL=MenuDivider.js.map
